var trim = require('./trim');

module.exports = function dasherize(str) {
  return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/dasherize.js
// module id = 713
// module chunks = 0